export default __webpack_public_path__ + "static/media/PAS-logo-white.3c142d8c.png";